export default __webpack_public_path__ + "static/pexels-rodnae-productions-6724507-3be961ad74ae0f21fe7ee8a0f4e69b91.jpg";